export const calculateAmount = (rate, quantity, transactionType) => {
    if (!rate || !quantity) return "";

    const baseAmount = rate * quantity;

    const charges =
        (baseAmount > 500000
            ? baseAmount * 0.00325
            : baseAmount > 50000
                ? baseAmount * 0.00345
                : baseAmount * 0.00375) + 25;

    const finalAmount =
        transactionType === "BUY"
            ? baseAmount + charges
            : baseAmount - charges;

    return finalAmount.toFixed(2);
};